import { useState } from 'react';
import '../App.css';
import styles from '../assets/styles/info.module.css'
import Backarrow from '../components/Backarrow';
import { masterConfig } from '../configs/generalConfig';
import DownImg from '../assets/images/downarrow.png';
import versionInfo from '../version.json';

// import '../assets/styles/home.css'
const OSPREY_VERSION = versionInfo.version || "unknown (contact a Narwhal)";

function Info({currentTab, setCurrentTab, configYear}) {
    const [infoActivity,setInfoActivity] = useState(Object.fromEntries(
        Object.keys(masterConfig[2025].informationMegaObject).map(key => [key, false])
    ))
    
    function toggleSection(key) {
        setInfoActivity(prev => ({
            ...prev,
            [key]: !prev[key],
        }));
    }

    if(currentTab == "info"){
        return (
            <div className={styles.InfoPage}>
                <div>
                    <h1 className={styles.titlePage}>Extra Information</h1>
                </div>
                {Object.entries(masterConfig[configYear].informationMegaObject).map(([key, info]) => (
                    <div key={key} className={styles.infoSection}>
                        <div className={styles.infodropper} onClick={() => toggleSection(key)}>
                            <h2>{info.title}</h2>
                            <img 
                                src={infoActivity[key] ? DownImg : DownImg}
                                alt={"clickArrow"} 
                                className={`${styles.downarrow} ${infoActivity[key] ? styles.rotate : ''}`}/>
                        </div>
                        <div className={infoActivity[key] ? styles.dataDesc : 'invisible'}>
                            {Object.entries(info.info).map(([xebec, moreInfo]) => (
                                <div key={xebec}>
                                    <h4>{moreInfo.subtitle}</h4>
                                    <p>{moreInfo.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                <Backarrow setCurrentTab={setCurrentTab}/>
                <div className={styles.footer}>
                    <p>Osprey Version {OSPREY_VERSION}</p>
                    <p>Created by Team 3128 The Aluminum Narwhals</p>
                    <p>This app is powered by <a href='https://www.thebluealliance.com/' target='blank'>The Blue Alliance</a></p>
                    
                </div>
            </div>
        );
    }
}

export default Info;
